import { render, staticRenderFns } from "./DagelijkseSoepLanding.vue?vue&type=template&id=4bbbcaae&scoped=true&"
import script from "./DagelijkseSoepLanding.vue?vue&type=script&lang=js&"
export * from "./DagelijkseSoepLanding.vue?vue&type=script&lang=js&"
import style0 from "./DagelijkseSoepLanding.vue?vue&type=style&index=0&id=4bbbcaae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbbcaae",
  null
  
)

export default component.exports